module.exports = __webpack_public_path__ + "static/media/glossy-scientific-microscope.627bdfa3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/glossy-scientific-microscope.svg
// module id = 651
// module chunks = 1